import { type JSX,useEffect, useRef, useState } from 'react';

import { Stack,Tooltip, Typography } from '@mui/material';

import { CopyToClipboard } from '../../../common/components/CopyToClipboard';

interface IInlineStyles {
    [key: string]: unknown
}

export interface PagetitleProps {
  resourceValue: string;
  resourceName: string;
  addExtraSpaceBeforeValue?: boolean;
  copyToClipboard?: boolean;
  licenseDetailsInlineStyles?: IInlineStyles;
}

const DEFAULT_RESOURCE_TYPE_INLINE_STYLES = {
    maxWidth: '35ch',
    justifyContent: 'left',
    display: 'flex',
    alignItems: 'center'
};

export function LicenseDetailsCustomLabel({
    resourceName,
    resourceValue,
    addExtraSpaceBeforeValue = false,
    copyToClipboard = false,
    licenseDetailsInlineStyles = DEFAULT_RESOURCE_TYPE_INLINE_STYLES

}: Readonly<PagetitleProps>): JSX.Element {
    const [isOverflowed, setIsOverflowed] = useState(false);
    const textElementRef = useRef<HTMLSpanElement | null>(null);

    useEffect(() => {
        if(textElementRef.current){
            setIsOverflowed(textElementRef.current.scrollWidth > textElementRef.current.offsetWidth);
        }
    }, []);

    return (
        <Stack
            direction="row"
            justifyContent="center"
            alignItems="center">

            {copyToClipboard && <CopyToClipboard content={resourceValue} clipboardInlineStyles={{ cursor: 'pointer', mr: 1, color: 'info.light' }}/>}

            <Tooltip title={resourceValue} disableHoverListener={!isOverflowed}>
                <Typography
                    variant="body2"
                    color="info.light"
                    noWrap
                    className='licenseDetailsLabel'
                    sx={licenseDetailsInlineStyles}>
                    {addExtraSpaceBeforeValue ?
                        <span className='ellipsis' ref={textElementRef}>{`${resourceName}: `}&nbsp;&nbsp;{resourceValue}</span> :
                        <span className='ellipsis' ref={textElementRef}>{`${resourceName}: ${resourceValue}`}</span>
                    }
                </Typography>
            </Tooltip>
        </Stack>
    );
}
